import { useState, useEffect } from 'react';
import { BloggerPost } from '../services/mockData';

export function useBookmarks() {
  const [bookmarks, setBookmarks] = useState<BloggerPost[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem('sebanews_bookmarks');
    if (stored) {
      try {
        setBookmarks(JSON.parse(stored));
      } catch (e) {
        console.error('Failed to parse bookmarks', e);
      }
    }
  }, []);

  const toggleBookmark = (post: BloggerPost) => {
    const isBookmarked = bookmarks.some(b => b.id === post.id);
    let updated: BloggerPost[];
    
    if (isBookmarked) {
      updated = bookmarks.filter(b => b.id !== post.id);
    } else {
      updated = [post, ...bookmarks];
    }
    
    setBookmarks(updated);
    localStorage.setItem('sebanews_bookmarks', JSON.stringify(updated));
  };

  const isBookmarked = (postId: string) => {
    return bookmarks.some(b => b.id === postId);
  };

  return { bookmarks, toggleBookmark, isBookmarked };
}
